var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F3BA2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1766_6969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6032 12.6033L14.002 9.20585L17.4022 12.6061L19.3787 10.6281L14.002 5.25L8.62524 10.6267L10.6032 12.6033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.0008L7.22654 12.0228L9.20447 14.0008L7.22654 15.9773L5.25 14.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6032 15.3968L14.002 18.7956L17.4022 15.3954L19.3801 17.3705L14.0034 22.7487L8.62524 17.3747L10.6032 15.3968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7957 14.0008L20.7722 12.0228L22.7501 13.9994L20.7722 15.9787L18.7957 14.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.008 13.9993L14.0024 11.9923L12.5193 13.4754L12.3479 13.6454L11.9968 13.9965L14.0024 16.0007L16.008 14.0006V13.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1766_6969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(5.25 5.25)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.149fe1e86742bf3195f14cdd30e707aa.svg";
export { ForwardRef as ReactComponent };